/* photo-gallery.js
 * Le masonry est géré en CSS (`columns`).
 * Ce fichier fournit une lightbox plein écran vanilla (sans dépendance) :
 * navigation préc/suiv (clavier + boutons), swipe mobile, légende, fermeture.
 */
(function () {
  var overlay, imgEl, captionEl, currentList = [], currentIndex = 0;

  function buildOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'pg-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<button class="pg-lightbox__close" type="button" aria-label="Fermer">&times;</button>' +
      '<button class="pg-lightbox__nav pg-lightbox__nav--prev" type="button" aria-label="Précédent">&#8249;</button>' +
      '<figure class="pg-lightbox__figure">' +
        '<img class="pg-lightbox__img" alt="">' +
        '<figcaption class="pg-lightbox__caption"></figcaption>' +
      '</figure>' +
      '<button class="pg-lightbox__nav pg-lightbox__nav--next" type="button" aria-label="Suivant">&#8250;</button>';
    document.body.appendChild(overlay);

    imgEl = overlay.querySelector('.pg-lightbox__img');
    captionEl = overlay.querySelector('.pg-lightbox__caption');

    overlay.querySelector('.pg-lightbox__close').addEventListener('click', close);
    overlay.querySelector('.pg-lightbox__nav--prev').addEventListener('click', function (e) { e.stopPropagation(); show(currentIndex - 1); });
    overlay.querySelector('.pg-lightbox__nav--next').addEventListener('click', function (e) { e.stopPropagation(); show(currentIndex + 1); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });

    var x0 = null;
    overlay.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    overlay.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(currentIndex + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  function show(i) {
    if (!currentList.length) return;
    currentIndex = (i + currentList.length) % currentList.length; // navigation circulaire
    var item = currentList[currentIndex];
    // fondu : on précharge la nouvelle image puis on l'affiche en transition
    imgEl.classList.add('is-loading');
    var pre = new Image();
    pre.onload = function () {
      imgEl.src = item.src;
      requestAnimationFrame(function () { imgEl.classList.remove('is-loading'); });
    };
    pre.src = item.src;
    imgEl.alt = item.caption || '';
    captionEl.textContent = item.caption || '';
    captionEl.style.display = item.caption ? '' : 'none';
    // une seule image → masquer les flèches
    var multi = currentList.length > 1 ? '' : 'none';
    overlay.querySelector('.pg-lightbox__nav--prev').style.display = multi;
    overlay.querySelector('.pg-lightbox__nav--next').style.display = multi;
  }

  function open(list, index) {
    if (!overlay) buildOverlay();
    currentList = list;
    show(index);
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('keydown', function (e) {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(currentIndex - 1);
    else if (e.key === 'ArrowRight') show(currentIndex + 1);
  });

  function init() {
    document.querySelectorAll('.js-photo-gallery').forEach(function (gallery) {
      var opens = Array.prototype.slice.call(gallery.querySelectorAll('.photo-gallery__open'));
      var list = opens.map(function (btn) {
        var fig = btn.closest('.photo-gallery__item');
        var cap = fig ? fig.querySelector('.photo-gallery__caption') : null;
        return { src: btn.getAttribute('data-pswp-src'), caption: cap ? cap.textContent.trim() : '' };
      });
      opens.forEach(function (btn, i) {
        if (btn.dataset.pgBound) return;     // évite les doublons de listeners
        btn.dataset.pgBound = '1';
        btn.addEventListener('click', function (e) { e.preventDefault(); open(list, i); });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
